import { URL } from '../../config.js';
import {axios} from '../../handlers/RequestHandler';
import store from '../store';
import Notification from '../../handlers/Notification';



const getTable = (data ) => {
    return (dispatch) => {
        return axios.get(URL + store.getState().company.id + data.url).then( (res) => {
            var table = {
                dataTransactions: res.data,
                sortTransactions: data.sort,
                ordTransactions: data.ord,
                pageTransactions: data.page,
                searchTransactions: data.search,
                ready: true,
                limitTransactions: store.getState().table.limitTransactions,
                mode: data.mode ? data.mode : 'all'
            };
            dispatch({
                type: 'SET_TABLE',
                table: table,
                redirect: ''
            });

        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title: "", msg: ""});
        });
    }
}

const initData = () => {
    return (dispatch) => {
        var table = {
            ready: false,
            dataTransactions: [],
            limitTransactions: 2,
            pageTransactions: 1,
            ordTransactions: 'desc',
            sortTransactions: 'id',
            searchTransactions: '',
            mode: 'all'
        };

        dispatch({
            type: 'SET_TABLE',
            table: table
        });
    }
}

const OLDtableUpdate = (res) => {
    var newdata = {...store.getState().table}
    if( newdata.dataTransactions.data.find( (data) => data.id === res.data.id) ){
        var update = newdata.dataTransactions.data.map( (item) => {
            if(item.id === res.data.id){
               item = res.data
            }
            return (item)
        })
        newdata.dataTransactions.data = update;
    }else{
        newdata.dataTransactions.data.push(res.data)
    }
    return newdata;
}

const OLDtableRemove = (res) => {
    var update = store.getState().table.dataTransactions.data.filter( (item) => {
        return (item.id !== res.data.id)
    })
    var newdata = {
        ...store.getState().table,
    }
    newdata.dataTransactions.data = update;

    return newdata;
}

/* ----------- new table methods */
const resetTableData = (name) => {
    return {
        type: 'RESET_TABLE_DATA',
        storeAttr: name
    }
}

const fetchingTableData = () => {
    return {
        type: 'WAIT_FOR_RESPONSE',
        preloader: true
    }
}



/* helper methods */

const tableUpdate = (res, table) => {
    return store.getState()[table].map( (item) => {
        if(item.id === res.data.id){
            if (res.data.hasOwnProperty("client")){ // TODO: el api no retorna el cliente en la tabla ordenes solo el id
                item = {
                    ...res.data,
                    client: item.client.name ? {...item.client} : {...res.data.client}
                }
            }
			else if (res.data.hasOwnProperty("admin_type")) {
				item = {
					account: item.account,
					...res.data
                }
			}
            else {
                item = res.data;
            }
        }
        return item;
    })
}

const tableClientsUpdate = (res, table) => {
	return store.getState()[table].data.map((item) => {
        if(item.id === res.data.id){
			if (item.account.type === 0) {  // si es cliente, entra en el if
				item.account.email = res.data.email;
				item = {
					account: item.account,
					...res.data
				}
			}
            else {
                item = res.data;
            }
        }
        return item;
    })
}


/**
 * elimina un item de tipo account en la litsta de objetos
 * @param  {Object} res   la respuesta del servidor
 * @param  {String} table el nombre del característica en el store ejm: "admins" o "providers"
 * @return {Array}       la lista de items si esa cuenta
 */
const tableRemoveAcount = (res, table) => {
	let storeData = (store.getState()[table] && store.getState()[table].data) || store.getState()[table];

    return storeData.filter( (item) => {
            return (item.account_id !== res.data.id);
        })
}


const tableRemove = (res, table) => {
    return store.getState()[table].filter( (item) => {
            return (item.id !== res.data.id);
        })
}


export {
	tableClientsUpdate,
	fetchingTableData,
	getTable,
	resetTableData,
	initData,
	tableRemoveAcount,
	tableUpdate,
	tableRemove,
	OLDtableUpdate,
	OLDtableRemove
};



// WEBPACK FOOTER //
// ./src/store/actions/tableActions.js